export default "__VITE_ASSET__Bg6VzeMh__"